import type { VFC } from 'react'
import { useContext, useMemo } from 'react'
import GlobalContext from '../../common/context/GlobalContext'
import {
  Title,
  Body,
  Banner
} from '@panwds/react-ui'
import {
  LABEL_ADD_IP_BANNER
} from '../constants/LabelConstants'
import { useLoadingContext } from '../../common/context/LoadingContext'

const IpAllowBanner: VFC<any> = () => {

  const { treeReducer, iamReducer } = useContext(GlobalContext)
  const { loading } = useLoadingContext()

  const { selectedTreeNode } = treeReducer
  const { allowedIps } = iamReducer

  const showBanner = useMemo(() => {
    return !!selectedTreeNode && !loading && !allowedIps.length
  }, [selectedTreeNode, loading, allowedIps.length])

  return (
    <div className='cm-flex cm-flex-col cm-w-full cm-p-3'>
      <Title
        level={2}
        addClassName='cm-font-bold'
      >
        {selectedTreeNode?.display_name}
      </Title>
      <div className='cm-flex cm-flex-row cm-gap-1'>
        {!!selectedTreeNode?.vertical && (
          <>
            <Body>{selectedTreeNode.vertical}</Body>
            <Body>|</Body>
          </>
        )}
        <Body>{selectedTreeNode?.id}</Body>
      </div>
      {showBanner && (
        <div className='cm-pt-3 cm-w-full'>
          <Banner type='inline' appearance='standard' showIcon>
            {LABEL_ADD_IP_BANNER}
          </Banner>
        </div>
      )}
    </div>
  )
}

export default IpAllowBanner
